class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    // body.overflow-hidden alone doesn't stop scrolling here: the site runs
    // Lenis for smooth-scroll (see inscription.js / product-redesign.js's
    // size picker, which both already do this), and Lenis drives scroll
    // through its own JS/transform mechanism rather than the native
    // overflow property, so it keeps scrolling the page underneath the
    // drawer unless explicitly told to stop. Same pattern as those drawers.
    if (window.__lenis) window.__lenis.stop();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);

    // Resuming Lenis (its own rAF loop doing scroll math every frame,
    // synced to GSAP's ScrollTrigger) at the exact same instant the
    // slide-out transform transition starts competes for the main
    // thread and was showing up as the close animation "lagging" /
    // stuttering instead of sliding smoothly. Keep the page frozen for
    // the duration of the transition (matches the 420ms in
    // cart-drawer-premium.css) and only unfreeze once the panel has
    // actually finished animating off-screen.
    var inner = this.querySelector('.drawer__inner');
    var unfreeze = () => {
      document.body.classList.remove('overflow-hidden');
      if (window.__lenis) window.__lenis.start();
    };
    if (inner) {
      var unfroze = false;
      var onTransitionEnd = (evt) => {
        if (evt.target !== inner || evt.propertyName !== 'transform') return;
        if (unfroze) return;
        unfroze = true;
        inner.removeEventListener('transitionend', onTransitionEnd);
        unfreeze();
      };
      inner.addEventListener('transitionend', onTransitionEnd);
      // Fallback in case transitionend never fires (e.g. reduced-motion
      // users, whose transition duration collapses to ~0 — see
      // premium-ux.css) so scroll never stays locked indefinitely.
      setTimeout(() => {
        if (unfroze) return;
        unfroze = true;
        inner.removeEventListener('transitionend', onTransitionEnd);
        unfreeze();
      }, 500);
    } else {
      unfreeze();
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
